export const RoutesConfig = {
	Application: "/",
	Login: "/",
	Dashboard: "/dashboard",
	Contact: "/contact",
	WhatsAppContact: "/whatsapp-contact",
	Company: "/company",
	WhatsAppCompany: "/whatsapp-company",
	Deal: "/deal",
	WhatsAppDeal: "/whatsapp-deal",
	Ticket: "/ticket",
	WhatsAppTicket: "/whatsapp-ticket",
	Admin: "/admin",
	UserLogin: "/login",
	Invite: "/invite"
}
